export const refLayersToInclude = [
  {
    layer: "Paddlesports",
    overrideTitle: "Intensity (low to high)",
    tooltip:
      "Mapped intensity values of paddle sport activities (i.e. non-motorized water sports such as stand-up paddleboarding and kayaking) based on TripAdvisor and Flickr photos and TripAdvisor reviews, buffered out from the attraction locations; values are unitless and expressed from high to low values.",
    measurement: "Intensity (low to high)",
  },
  {
    layer: "Seafood Restaurants",
    overrideTitle: "Concentration (low to high)",
    tooltip:
      "Mapped concentration values of seafood restaurants and other attractions serving fresh fish based on TripAdvisor reviews, with values buffered out to reduce errors of locational accuracy; values are unitless and expressed from high to low values.",
    measurement: "Concentration (low to high)",
  },
  {
    layer: "Population Analysis - Number of People",
    title: "Number of People per 90 square meters",
    tooltip:
      "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
    link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 3,
        visible: false,
      },
      {
        id: 2,
        visible: false,
      },
      {
        id: 1,
        visible: false,
      },
      {
        id: 0,
        visible: true,
      },
    ],
    isRaster: true,
  },
  {
    layer: "Population Analysis - Number of Women",
    title: "Number of Women per 90 square meters",
    tooltip:
      "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
    link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 3,
        visible: false,
      },
      {
        id: 2,
        visible: false,
      },
      {
        id: 1,
        visible: true,
      },
      {
        id: 0,
        visible: false,
      },
    ],
    isRaster: true,
  },
  {
    layer: "Population Analysis - Number of Elderly",
    title: "Number of Elderly (over 60 years old) per 90 square meters",
    tooltip:
    "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
  link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 3,
        visible: false,
      },
      {
        id: 2,
        visible: true,
      },
      {
        id: 1,
        visible: false,
      },
      {
        id: 0,
        visible: false,
      },
    ],
    isRaster: true,
  },
  {
    layer: "Population Analysis - Number of Children",
    title: "Number of Children (under 5 years old) per 90 square meters",
    tooltip:
      "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
    link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 3,
        visible: true,
      },
      {
        id: 2,
        visible: false,
      },
      {
        id: 1,
        visible: false,
      },
      {
        id: 0,
        visible: false,
      },
    ],
    isRaster: true,
  },
];

export const CRT = {
  stats: {
    large: [
      {
        name: "Expenditures (USD)",
        title: "Modelled Expenditure for On-Reef Activities per Year",
        tooltip:
          "Mapped estimates of the annual dollar expenditure of coral reefs to the tourism sector from on-reef tourism activities such as snorkelling and SCUBA. Values were assigned based on reef use intensity determined by proximity to dive sites and underwater photography. Values are expressed in $USD.",
        measurement: "($USD)",
      },
      {
        name: "Total visitation value (# of people)",
        title: "Total Visitation Value (# of people)",
        tooltip:
          "Mapped estimates of the annual visitor numbers which can be attributed to on-reef activities such as snorkelling and SCUBA. Values were assigned geographically based on reef use intensity determined by proximity to dive sites and underwater photography. Values are expressed in visitor numbers/ha, representing the additionality of tourists who are present in the country because of these activities.",
        measurement: "",
      },
      {
        name: "Highest value reefs (top 10%) generate (USD)",
        title: "Highest Value Tourist Reefs",
        tooltip:
          "Map highlighting the reefs estimated to have the highest annual dollar values in the region.  This map depicts the 10% of reef areas (top decile) with the highest values in red, and the remainder of the reefs in gray.",
        measurement: "($USD)",
      },
    ],
    small: [
      {
        name: "Total reef area (sqkm)",
        title: "Total Reef Area",
        tooltip:
          "Reef area based on TNC Worldview-derived benthic habitat map products (2m resolution), resampled to 100m grid cells to account for broader area around which on-reef tourism activities are likely to occur. Area estimates includes all coral classes, and any hardground area within 1km of non-wreck dive sites. Additional diving habitat around Monkey Shoals (St Kitts) using depth contours.",
        measurement: "(sqkm)",
      },
      {
        name: "Reefs used for tourism (sqkm, %)",
        title: "Coral Reefs Used for Tourism",
        tooltip:
          "Includes any 100m grid cell of reef habitat with that had a modelled expenditures or visitation value",
        measurement: "",
      },
    ],
  },
  data: [
    {
      name: "CROP Countries",
      layers: [
        {
          name: "Modelled visitation value of on-reef tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_04282021_WFL1/FeatureServer/3",
        },
        {
          name: "Modelled expenditure for on-reef activities per year (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_04282021_WFL1/FeatureServer/0",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_04282021_WFL1/FeatureServer/2",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_04282021_WFL1/FeatureServer/1",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_04282021_WFL1/FeatureServer/5",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_04282021_WFL1/FeatureServer/4",
        },
        {
          name: "Statistics Table",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/arcgis/rest/services/MOWCROP_AppStats_05042021/FeatureServer/0",
        },
      ],
    },
    {
      name: "Dominica",
      layers: [
        {
          name: "Modelled visitation value of on-reef tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/15",
        },
        {
          name: "Modelled expenditure for on-reef activities per year (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/0",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/10",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/5",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/25",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/20",
        },
      ],
    },
    {
      name: "Grenada",
      layers: [
        {
          name: "Modelled visitation value of on-reef tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/16",
        },
        {
          name: "Modelled expenditure for on-reef activities per year (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/1",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/11",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/6",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/26",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/21",
        },
      ],
    },
    {
      name: "Saint Kitts and Nevis",
      layers: [
        {
          name: "Modelled visitation value of on-reef tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/17",
        },
        {
          name: "Modelled expenditure for on-reef activities per year (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/2",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/12",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/7",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/27",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/22",
        },
      ],
    },
    {
      name: "Saint Lucia",
      layers: [
        {
          name: "Modelled visitation value of on-reef tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/18",
        },
        {
          name: "Modelled expenditure for on-reef activities per year (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/3",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/13",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/8",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/28",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/23",
        },
      ],
    },
    {
      name: "Saint Vincent and the Grenadines",
      layers: [
        {
          name: "Modelled visitation value of on-reef tourism (per ha)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/19",
        },
        {
          name: "Modelled expenditure for on-reef activities per year (US$)",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/4",
        },
        {
          name: "Overnight Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/14",
        },
        {
          name: "Cruise Expenditure",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/9",
        },
        {
          name: "Overnight Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/29",
        },
        {
          name: "Cruise Visitation",
          url: "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Coral_Reef_Tourism_Scaled_per_Country_WFL1/FeatureServer/24",
        },
      ],
    },
  ],
};

export const ReferenceConfig = [
    {
      url: "https://oceanwealth.org/wp-content/uploads/2021/05/Output_4_Coral_Reef_Tourism_Report_Final_20201130REDUCED.pdf",
      label: "Technical Report",
    },
    {
      url: "https://oceanwealth.org/wp-content/uploads/2021/06/On-Reef-Tourism-Technical-Summary.pdf",
      label: "Technical Summary",
    },
    {
      url: "https://tnc.box.com/shared/static/i2rpvan5ees56chcipnutul4elfknatz.zip",
      label: "Data Download",
    },
    {
      url: "https://oceanwealth.org/project-areas/caribbean/crop/country-summaries/",
      label: "Country Summary"
    },
  ];
